import $ from 'jquery';
import 'owl.carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';

export class MindboxCarousel {
    static init(responsive) {
        $('.js-owl-carousel-mindbox').owlCarousel({
            margin: 20,
            stagePadding: true,
            loop: true,
            nav: true,
            navText: [],
            dots: false,
            pagination: true,
            responsive: responsive
                ? responsive
                : {
                      0: {
                          items: 2,
                          dots: true
                      },
                      481: {
                          items: 2,
                          dots: true
                      },
                      768: {
                          items: 3,
                          nav: true
                      },
                      992: {
                          items: 4,
                          nav: true
                      },
                      1200: {
                          items: 5,
                          nav: true
                      }
                  }
        });
    }
}



// WEBPACK FOOTER //
// ./modules/mindbox/mindbox-carousel.js